import React, { useMemo } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls';
import { useProgramUIContext } from './ProgramUIContext';
import ProgramTable from './program-table/ProgramTable';
import { ProgramFilter } from './program-table/program-filter/ProgramFilter'
import { RoleChecker } from '../../../../RoleChecker';

export const ProgramCard = () => {

	const programUIContext = useProgramUIContext();
	const programUIProps = useMemo(() => {
		return {
			newProgramButtonClick: programUIContext.newProgramButtonClick,
		};
	}, [programUIContext]);

	return (
		<Card>
			<CardHeader title="Program List">
				<CardHeaderToolbar>
					{RoleChecker('Create', 'program') && <button
						type="button"
						className="btn btn-primary"
						onClick={programUIProps.newProgramButtonClick}
					>New Program
					</button>}
				</CardHeaderToolbar>
			</CardHeader>
			<CardBody>
				<ProgramFilter />
				<ProgramTable />
			</CardBody>
		</Card>
	);
};
